
import React from "react";
import { BarChart } from "@/components/ui/charts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export interface StudentRetentionChartProps {
  className?: string;
  dateRange?: { from: Date; to: Date };
}

export function StudentRetentionChart({ className, dateRange }: StudentRetentionChartProps) {
  // Sample data - in a real app, this would come from an API
  // and would be filtered by the dateRange prop
  const data = [
    { 
      cohort: "2021", 
      "Year 0": 85, 
      "Year 1": 62, 
      "Year 2": 48,
      "Year 3": 32,
      "Year 4": 24
    },
    { 
      cohort: "2022", 
      "Year 0": 92, 
      "Year 1": 72, 
      "Year 2": 55,
      "Year 3": 40,
      "Year 4": 0
    },
    { 
      cohort: "2023", 
      "Year 0": 78, 
      "Year 1": 65, 
      "Year 2": 0,
      "Year 3": 0,
      "Year 4": 0
    },
    { 
      cohort: "2024", 
      "Year 0": 88, 
      "Year 1": 0, 
      "Year 2": 0,
      "Year 3": 0,
      "Year 4": 0
    },
    { 
      cohort: "2025", 
      "Year 0": 40, 
      "Year 1": 0, 
      "Year 2": 0,
      "Year 3": 0,
      "Year 4": 0
    }
  ];

  return (
    <Card className="bg-white/50 backdrop-blur-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Student Retention (5 Year View)</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <BarChart
            data={data}
            index="cohort"
            categories={["Year 0", "Year 1", "Year 2", "Year 3", "Year 4"]}
            colors={["blue", "green", "purple", "orange", "red"]}
            valueFormatter={(value) => `${value} students`}
          />
        </div>
        <div className="text-xs text-muted-foreground mt-2">
          Each column shows how many students from a cohort year continued in subsequent years
        </div>
      </CardContent>
    </Card>
  );
}
